
define('hbs!glu/grid/filter/badges/auxControl.hbs',['hbs','handlebars'], function(hbs, Handlebars){var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "    <button type=\"button\" class=\"btn btn-tertiary js-clear-filters\" aria-label=\""
    + this.escapeExpression((helpers.locale || (depth0 && depth0.locale) || helpers.helperMissing).call(depth0,"clear",{"name":"locale","hash":{},"data":data}))
    + "\">"
    + this.escapeExpression((helpers.locale || (depth0 && depth0.locale) || helpers.helperMissing).call(depth0,"clear",{"name":"locale","hash":{},"data":data}))
    + "</button>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.filtersEnabled : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});Handlebars.registerPartial('glu/grid/filter/badges/auxControl.hbs', t);return t;});
